<template>
  <div class="recharge">
    <div class="inner">
      <div class="title">{{ $t("購買CASH") }}</div>
      <div class="question">{{ $t("點數是什麼？") }}</div>
      <div class="answer">
        <p>
          {{ $t("玩家必須先儲值點數，方可在 購買元寶 頁面購買karos的元寶") }}
        </p>
        <p>{{ $t("儲值點數時，請先確認金額後再購買") }}</p>
      </div>
      <div class="products" v-if="dataArr.length > 0">
        <div
          class="products_item"
          v-for="(item, index) in dataArr"
          :key="index"
        >
          <img src="@/assets/img/mall/img_commodity02_Shopping.png" alt="" />
          <div class="item_title">{{ item.product }}</div>
          <div class="price">{{ item.point }}</div>
          <div class="buy-butt submit">
            <el-button type="primary" style="width: 100%" @click="buy(item)">{{
              $t("購買")
            }}</el-button>
          </div>
        </div>
      </div>
      <Nodata v-else />
    </div>
    <Dialog
      v-if="showDetail"
      :title="$t('購買元寶')"
      :cancelText="$t('取消購買')"
      :submitText="$t('確認購買')"
      @cancel="cancel"
      @submit="confirm"
    >
      <div class="desc">{{ this.$t("您正在購買元寶") }}</div>
      <div class="product-detail">
        <div class="detail-item">
          <div class="label">{{ $t("道具資訊：") }}</div>
          <div>{{ buyingItem.description }}</div>
        </div>
        <div class="detail-item">
          <div class="label">{{ $t("購買價格：") }}</div>
          <div>{{ priceFormat(buyingItem.point) }} {{ $t("點") }}</div>
        </div>
      </div>
      <div class="product-detail">
        <div class="detail-item">
          <div class="detail-label">{{ $t("持有點數：") }}</div>
          <div>{{ userInfo.total_point }} {{ $t("點") }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t("消耗點數：") }}</div>
          <div>{{ buyingItem.point }} {{ $t("點") }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ $t("扣除後點數：") }}</div>
          <div>{{ userInfo.total_point - buyingItem.point }} {{ $t("點") }}</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { postPropRecord } from "@/api/pay";
import { propProduction } from "@/api/mall";
import { getUserInfo } from "@/api/login";
import cookie from "js-cookie";
import filters from "@/utils/filters";
export default {
  data() {
    return {
      dataArr: [],
      userInfo: {},
      showDetail: false,
    };
  },
  created() {
    this.getData();
    this.$store.dispatch("getUser");
  },
  methods: {
    originPriceFormat: filters.priceFormat,
    priceFormat(value) {
      return filters.priceFormat(value);
    },
    async getData() {
      const res = await propProduction({ limit: 9999 });
      this.dataArr = res.data.results;
    },
    async buy(item) {
      const res = await getUserInfo();
      if (res.status === 200) {
        this.userInfo = res.data;
        this.buyingItem = item;
        this.showDetail = true;
      } else {
        cookie.remove("token");
        cookie.remove("userInfo");
        window.localStorage.setItem("return_url", this.$route.fullPath);
        location.href =
          this.$store.state.header.app_oauth2 +
          `/#/login?client_id=${this.$store.state.header.app_account_client_id}&return_url=${this.$store.state.header.app_redirect_url}`;
      }
    },
    async confirm() {
      if (this.userInfo.total_point >= this.buyingItem.point) {
        const res = await postPropRecord({
          propproduct: this.buyingItem.id,
          server: 1,
        });
        if (res.status === 201) {
          this.$message.success(this.$t("購買成功"));
          const user = await getUserInfo();
          cookie.set("userInfo", user.data);
          this.$store.commit("SET_USERINFO", user.data);
          this.showDetail = false;
        }
      } else {
        this.$message.error(this.$t("點数不足"));
      }
    },
    cancel() {
      this.showDetail = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.recharge {
  .inner {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    text-align: left;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }
    .title {
      font-size: 48px;
      color: #000;
      margin: 38px 0;
      @media only screen and (max-width: 900px) {
        width: 100%;
        font-size: 24px;
        margin: 19px 0;
      }
    }
    .question {
      font-size: 22px;
      color: #c6a86c;
      margin: 15px 0;
      @media only screen and (max-width: 900px) {
        width: 100%;
        font-size: 14px;
        margin: 19px 0;
      }
    }
    .answer {
      font-size: 18px;
      margin: 0 0;
      line-height: 29px;
      @media only screen and (max-width: 900px) {
        font-size: 14px;
        line-height: 1.2;
      }
      p {
        @media only screen and (max-width: 900px) {
          margin: 16px 0;
        }
      }
    }
    .products {
      display: flex;
      align-items: flex-start;
      margin-top: 40px;
      margin-bottom: 100px;
      flex-wrap: wrap;
      @media only screen and (max-width: 900px) {
        margin-top: 20px;
        margin-bottom: 50px;
      }
      .products_item {
        width: 260px;
        height: 289px;
        background: #fff;
        text-align: center;
        margin-bottom: 25px;
        margin-right: 25px;
        @media only screen and (max-width: 900px) {
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: 12px;
          width: 260px;
          height: 289px;
        }
        img {
          width: 87px;
          height: 87px;
          margin: 24px;
          @media only screen and (max-width: 900px) {
            width: 87px;
            height: 87px;
            margin: 24px;
          }
        }
        .item_title {
          font-size: 28px;
          color: #c6a86c;
          padding-bottom: 20px;
          @media only screen and (max-width: 900px) {
            font-size: 24px;
          }
        }
        .price {
          font-size: 18px;
          color: #616161;
          line-height: 32px;
          @media only screen and (max-width: 900px) {
            font-size: 18px;
            line-height: 32px;
          }
        }
        .buy-butt {
          line-height: 40px;
          width: 75%;
          background: #c6a86c;
          border-radius: 4px;
          text-align: center;
          color: #fff;
          margin: auto;
          cursor: pointer;
          font-weight: 400;
          @media only screen and (max-width: 900px) {
            line-height: 40px;
          }
        }
      }
    }
  }
}
.desc {
  font-size: 22px;
  font-weight: 400;
  color: #c6a86c;
  margin-top: 30px;
  @media only screen and (max-width: 900px) {
    margin-top: 30px;
    font-size: 22px;
  }
}
.product-detail {
  margin: 35px 0;
  line-height: 32px;
  text-align: left;
  @media only screen and (max-width: 900px) {
    margin: 35px 0;
    line-height: 32px;
  }
  .detail-item {
    display: flex;
    .label {
      width: 98px;
      @media only screen and (max-width: 900px) {
        width: 98px;
      }
    }
  }
}
</style>
